import React, { useState, useEffect } from "react";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import BatteryChargingFullIcon from "@material-ui/icons/BatteryChargingFull";
import { withRouter } from "react-router-dom";
import Loader from "../../Components/Preloader/index";
import { connect } from "react-redux";
import battery from "../../Assets/Images/battery-car.svg";
import Battry from "./battery";

import {
  updateBreadcrumbs,
  updateToasterConfig,
} from "../../redux/modules/app/actions";
import { isEmptyObject } from "jquery";
const Heatmap=(props)=>{
const [data,setData]=useState({})
const [socket,setSocket]=useState(null)
const [isConnected, setIsConnected] = useState(false);
const connectWebSocket = (props) => {
const newSocket = new WebSocket(window.location.host=="dev-admin.parkzeus.in"?'wss://dev.parkzeus.in/notification-service/ws/live-sensor-data':'wss://beta.parkzeus.in/notification-service/ws/live-sensor-data');
    newSocket.onopen = () => {
      console.log("WebSocket connection established");
      newSocket.send("Socket connection established");
      setIsConnected(true);
    };

    newSocket.onmessage = (event) => {
      console.log("Received data from server: ", event.data);
      console.log(event.data);
      setData(JSON.parse(event.data));
    };

    newSocket.onerror = (error) => {
      console.error("WebSocket error: ", error);
    };

    newSocket.onclose = () => {
      console.log("WebSocket connection closed");
      setIsConnected(false);
      setTimeout(connectWebSocket, 3000);
    };

    setSocket(newSocket);
  };

  useEffect(() => {
    props.dispatch(updateBreadcrumbs("heatmap"));
    connectWebSocket();
    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, []);

  const Card = ({ value, tenant, parking }) => (
    <div
      style={{
        height: "150px",
        width: "100%",
        borderRadius: "5px",
        backgroundColor: "white",
        gap: "10px",
        border: "1px solid gray",
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "10px",
          }}
        >
          <div
            style={{
              height: "100px",
              width: "100px",
              borderRadius: "100%",
              border: "1px solid white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              backgroundColor: "rgba(1, 192, 203, 1)",
              left: "5px",
            }}
          >
            <img style={{ height: "25px", width: "25px" }} src={battery} />
            <p
              style={{ color: "white", fontWeight: "bold", display: "inline" }}
            >
              {value ? value : "--"} mV
            </p>
          </div>

          <div>
            <span>
              {" "}
              <p>tenant:</p>
              <p style={{ color: "gray" }}>
                {tenant ? tenant : <div style={{ width: "100%" }}>--</div>}
              </p>
            </span>
            <span>
              {" "}
              <p>parking spot:</p>{" "}
              <p style={{ color: "gray" }}>
                {new String(parking).split(":")[3]
                  ? new String(parking).split(":")[3]
                  : "--"}
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
  //isEmptyObject(data)?<Loader/>:

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gridTemplateRows: "1fr 1fr",
        placeItems: "center",
        padding: "10px",
        gap: "10px",
        marginLeft: "10px",
        marginRight: "10px",
      }}
    >
      <Battry
        percentage={data?.value}
        parking={data?.urn}
        tenant={data?.tenant}
        isactive={true}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updateBreadcrumbs,
  updateToasterConfig,
  dispatch,
});
//method to connect react with redux
export default withRouter(connect(null, mapDispatchToProps)(Heatmap));
